module.exports = __webpack_public_path__ + "img/product-img_3.6b682082.png";